import Vue from "vue";
import Vuex from "vuex";
import axios from "../services/axios";
import axiosAdmin from "../services/axiosAdmin";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    globalToken: process.env.VUE_APP_GLOBAL_TOKEN,
    cpfCnpj: null,
    dividas: [],
    acordos: [],
    corPrimaria: {
      "--color": null,
      "--hovercolor": null,
    },
    corSecundaria: {
      "--color": null,
      "--hovercolor": null,
    },
    lançamentosfuturos: [],
    parceiro: null,
    parceiroConfig: null,
    acerteAquiConfig: null,
    pessoa: null,
    empresas: [],
    loading: false,
    loadingMessage: "",
    leads: [],
    messageModal: {
      show: false,
      title: "",
      message: "",
      styleMessage: "danger",
    },
    messageSnackbar: {
      show: false,
      message: "",
    },
    user: {
      id: null,
      name: null,
    },
  },
  mutations: {
    SET_ACERTE_AQUI_CONFIG(state, payload) {
      state.acerteAquiConfig = payload;
    },
    SET_CPF_CNPJ(state, payload) {
      state.cpfCnpj = payload;
    },
    SET_PARCEIRO(state, payload) {
      state.parceiro = payload;
    },
    SET_PARCEIRO_CONFIG(state, payload) {
      state.parceiroConfig = payload;
    },
    SET_COR_PRIMARIA(state, payload) {
      state.corPrimaria = payload;
    },
    SET_COR_SECUNDARIA(state, payload) {
      state.corSecundaria = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_LOADING_MESSAGE(state, payload) {
      state.loadingMessage = payload;
    },
    SET_PESSOA(state, payload) {
      state.pessoa = payload;
    },
    SET_EMPRESAS(state, payload) {
      state.empresas = payload;
    },
    SET_ACORDOS(state, payload) {
      state.acordos = payload;
    },
    SET_DIVIDAS(state, payload) {
      state.dividas = payload.sort(
        (a, b) =>
          +(a.loj_fantasia > b.loj_fantasia) ||
          -(a.loj_fantasia < b.loj_fantasia)
      );
    },
    SET_LEADS(state, payload) {
      state.leads = payload;
    },
    SET_LANCAMENTOS_FUTUROS(state, payload) {
      state.lançamentosfuturos = payload;
    },
    CHANGE_MESSAGE_SNACKBAR(state, payload) {
      state.messageSnackbar.show = !state.messageSnackbar.show;
      state.messageSnackbar.message = payload;
    },
    CHANGE_MESSAGE_MODAL(state, payload) {
      state.messageModal = payload;
    },
  },
  actions: {
    action_openMessageModal(context, payload) {
      const msg = {
        show: true,
        styleMessage: payload.styleMessage,
        title: payload.title,
        message: payload.message,
      };
      if (payload.title === undefined && payload.message === undefined) {
        msg.title = "Ocorreu um erro!";
        msg.message =
          "Verifique a sua conexão com a internet e tente novamente mais tarde.";
      } else if (
        (payload.message === undefined || payload.message === null) &&
        payload.title !== undefined
      ) {
        msg.title = "Atenção !";
        msg.message = title;
      }
      context.commit("CHANGE_MESSAGE_MODAL", msg);
    },
    async action_getCpfCnpj(context, payload, state) {
      context.commit("SET_EMPRESAS", []);
      context.commit("SET_LOADING", true);
      localStorage.removeItem("cpf_cnpj");
      localStorage.removeItem("empresas");
      localStorage.removeItem("pessoa");
      return await axios
        .post(`/api.php?portal=1&a=portal&b=getCpfCnpj`, payload)
        .then((response) => {
          if (response.data.retorno && response.data.dados) {
            let empresas = [];
            let pessoa = null;
            Object.entries(response.data.dados.empresa).forEach(
              ([key, value]) => {
                value.lojas.forEach((loja) => {
                  empresas.push({
                    ...loja,
                    pessoa: value.pessoa,
                    emp_codigo: value.emp_codigo,
                    pes_codigo: value.pessoa.pes_codigo,
                  });
                });
                pessoa = value.pessoa.pes_nome;
              }
            );
            context.commit("SET_CPF_CNPJ", payload.cpfCnpj);
            context.commit("SET_EMPRESAS", empresas);
            context.commit("SET_PESSOA", pessoa);
            localStorage.setItem("cpf_cnpj", payload.cpfCnpj);
            localStorage.setItem("empresas", JSON.stringify(empresas));
            localStorage.setItem("pessoa", pessoa);
          }
          context.commit("SET_LOADING", false);
          return response;
        })
        .catch((error) => {
          context.commit("SET_LOADING", false);
          return error;
        });
    },
    async action_getValores(context, payload) {
      context.commit("SET_DIVIDAS", []);
      context.commit("SET_LOADING", true);
      return await axios
        .post(`/api.php?portal=1&a=portal&b=getValores`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_getValoresFuturos(context, payload) {
      context.commit("SET_DIVIDAS", []);
      context.commit("SET_LOADING", true);
      return await axios
        .post(`/api.php?portal=1&a=portal&b=getValoresFuturos`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_getValoresAcordo(context, payload) {
      // context.commit("SET_LOADING", true);
      return await axios
        .post(`/api.php?portal=1&a=portal&b=getValoresAcordo`, payload)
        .then((response) => {
          let acordos = {
            boleto: [],
            cartao: [],
          };
          if (response.data.retorno && response.data.dados) {
            Object.entries(response.data.dados).forEach(([key, value]) => {
              if (key === "pagamento_boleto") {
                Object.entries(value).forEach(
                  ([keyParBoleto, valueParBoleto]) => {
                    acordos.boleto.push({
                      ...valueParBoleto,
                      pra_codigo: keyParBoleto,
                      tipo_parcela: "boleto",
                    });
                  }
                );
              } else if (key === "valor_total_pro_cartao") {
                Object.entries(value[0]).forEach(
                  ([keyParCartao, valueParCartao]) => {
                    acordos.cartao.push({
                      ...valueParCartao,
                      tipo_parcela: "cartao",
                    });
                  }
                );
              }
            });
          }
          context.commit("SET_LOADING", false);
          return acordos || response;
        })
        .catch((error) => {
          context.commit("SET_LOADING", false);
          return error;
        });
    },
    async action_salvarAcordo(context, payload) {
      context.commit("SET_LOADING", true);
      return await axios
        .post(`/api.php?a=portal&b=salvarAcordo`, payload)
        .then((response) => {
          if (response.data.retorno) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Acordo criado com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          } else {
            context.commit("CHANGE_MESSAGE_MODAL", {
              show: true,
              title: "Atenção",
              message: response.data.mensagem,
              styleMessage: "danger",
            });
          }
          context.commit("SET_LOADING", false);
          return response;
        })
        .catch((error) => {
          context.commit("CHANGE_MESSAGE_MODAL", {
            show: true,
            title: "Atenção",
            message: "",
            styleMessage: "danger",
          });
          context.commit("SET_LOADING", false);
          return error;
        });
    },
    async action_getAcordos(context, payload) {
      context.commit("SET_ACORDOS", []);
      context.commit("SET_LOADING", true);
      return await axios
        .post(`/api.php?portal=1&a=portal&b=getAcordos`, payload)
        .then((response) => {
          let acordos = [];
          if (response.data.dados) {
            response.data.dados.forEach((acor) => {
              acor.acordos.forEach((acordo) => {
                acordos.push({
                  ...acordo,
                  emp_codigo: acor.emp_codigo,
                  pessoa: acor.pessoa,
                });
              });
            });
          }
          context.commit("SET_ACORDOS", acordos);
          return acordos;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_getTelefone(context, payload) {
      context.commit("SET_ACORDOS", []);
      context.commit("SET_LOADING", true);
      return await axios
        .post(`/api.php?portal=1&a=portal&b=getTelefone`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_getTelefone(context, payload) {
      context.commit("SET_ACORDOS", []);
      context.commit("SET_LOADING", true);
      return await axios
        .post(`/api.php?portal=1&a=portal&b=getTelefone`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_cadastrarLead(context, payload) {
      return await axios
        .post(`/api.php?portal=1&a=portal&b=cadastrarLead`, payload)
        .then((response) => {
          if (response.data.retorno) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Proposta cadastrada com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          } else {
            context.commit("CHANGE_MESSAGE_MODAL", {
              show: true,
              title: "Atenção",
              message: response.data.mensagem,
              styleMessage: "danger",
            });
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_login(context, payload) {
      return await axiosAdmin
        .post(`/api/login`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_alterar_senha(context, payload) {
      return await axiosAdmin
        .put(`/api/editar_senha`, payload)
        .then((response) => {
          if (response) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Senha atualizada com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          context.commit("CHANGE_MESSAGE_MODAL", {
            show: true,
            title: "Atenção",
            message: error.response.data.message,
            styleMessage: "danger",
          });
        });
    },
    async action_cadastro_parceiro(context, payload) {
      return await axiosAdmin
        .post(`/api/parceiro`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_editar_parceiro(context, payload) {
      return await axiosAdmin
        .put(`/api/parceiro/` + payload.id, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_deletar_parceiro(context, payload) {
      return await axiosAdmin
        .delete(`/api/parceiro/` + payload.id, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_buscar_parceiro(context, payload) {
      return await axiosAdmin
        .get(`/api/parceiro/` + payload.id + `/info`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_buscar_todos_parceiros(context, payload) {
      return await axiosAdmin
        .get(`/api/parceiro`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_buscar_dados_pagina_parceiro(context, payload) {
      return await axiosAdmin
        .get(`api/parceiro/${payload.parceiro}/info`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_atualizar_dados_cadastrais(context, payload) {
      return await axios
        .post(`/api.php?portal=1&a=portal&b=atualizarDadosCadastrais`, payload)
        .then((response) => {
          if (response.data.retorno === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Dados atualizados com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_cadastrar_proposta(context, payload) {
      return await axios
        .post(`/api.php?portal=1&a=portal&b=cadastrarProposta`, payload)
        .then((response) => {
          if (response.data.retorno === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Proposta enviada com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_solicitar_ligacao(context, payload) {
      return await axios
        .post(`/api.php?portal=1&a=portal&b=solicitarLigacao`, payload)
        .then((response) => {
          if (response.data.retorno === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Solicitação enviada com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_contato_whatsapp(context, payload) {
      return await axios
        .post(`/api.php?portal=1&a=portal&b=contatoWhatsapp`, payload)
        .then((response) => {
          if (response.data.retorno === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Solicitação enviada com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_buscar_duvidas(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=getDuvidas`, payload)
        .then((response) => {
          if (response.data === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Dados recebidos com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_cadastrar_duvida(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=cadastrarDuvida`, payload)
        .then((response) => {
          if (response.data.retorno === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Duvida frequente adicionada com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_deletar_duvida(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=deletarDuvida`, payload)
        .then((response) => {
          if (response.data.retorno === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Duvida frequente deletada com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_editar_duvida(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=atualizarDuvida`, payload)
        .then((response) => {
          if (response.data.retorno === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Duvida frequente deletada com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_cadastrar_credor(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=cadastrarEmpresaCredora`, payload)
        .then((response) => {
          if (response.data.retorno === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Credor adicionado com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_buscar_empresas(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=getEmpresas`, payload)
        .then((response) => {
          if (response.data === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Dados recebidos com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_buscar_cep(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=consultarCEP`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log("error", error);
          return error;
        });
    },
    async action_buscar_planos(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=getPlanosAtivos`, payload)
        .then((response) => {
          if (response.data === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Dados recebidos com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          console.log("error", error);
          return error;
        });
    },
    async action_buscar_empresa_credora(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=getEmpresasCredoras`, payload)
        .then((response) => {
          if (response.data === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Dados recebidos com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          console.log("error", error);
          return error;
        });
    },
    async action_cadastrar_novo_credor(context, payload) {
      return await axios
        .post(`/api.php?a=portal&b=cadastrarCliente`, payload)
        .then((response) => {
          if (response.data === true) {
            context.commit(
              "CHANGE_MESSAGE_SNACKBAR",
              "Dados recebidos com sucesso!"
            );
            setTimeout(
              () => context.commit("CHANGE_MESSAGE_SNACKBAR", ""),
              5000
            );
          }
          return response;
        })
        .catch((error) => {
          console.log("error", error);
          return error;
        });
    },
    async action_salvar_etapa(context, payload) {
      return await axios
        .post(`/api.php?portal=1&a=portal&b=salvarEtapa`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_enviar_email(context, payload) {
      return await axios
        .post(`/api.php?a=mail&b=envio`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
    async action_getLead(context, payload) {
      context.commit("SET_LEADS", []);
      return await axios
        .post(`/api.php?portal=1&a=portal&b=getLead`, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          return error;
        });
    },
  },
});
